import type { SVGProps } from 'react';
const SvgBathSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.375 6.718a.467.467 0 0 1 .798-.33l.524.523a2.794 2.794 0 0 0 .478 2.855.85.85 0 0 0 .134 1.02.84.84 0 0 0 1.191 0l3.66-3.657a.844.844 0 0 0-1.02-1.325 2.78 2.78 0 0 0-1.828-.679c-.362 0-.71.07-1.026.193l-.524-.523a2.717 2.717 0 0 0-4.637 1.923V13a1.124 1.124 0 1 0 0 2.25h15.75c.622 0 1.125-.503 1.125-1.125S21.497 13 20.875 13h-13.5zm-2.25 9.657v.563c0 .998.436 1.898 1.125 2.517v1.42a1.124 1.124 0 1 0 2.25 0v-.562h9v.562c0 .622.503 1.125 1.125 1.125s1.125-.503 1.125-1.125v-1.42a3.37 3.37 0 0 0 1.125-2.517v-.563z"
    />
  </svg>
);
export default SvgBathSolid;
